import React from 'react'
import { useDispatch } from 'react-redux';
import { addItemToCart, removeCartItem, updateCartItem } from '../../state/Cart/Action';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button, IconButton } from '@mui/material';
import { IMAGES_URL } from "../../config/apiConfig";
export default function CartItem({ item }) {
    const dispatch = useDispatch();
    //const IMAGES_URL = "http://mapi.pt2000.com.vn/uploads/"
    const VND = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
    });
    const handleAdd = () => {
        const data = { productId: item.productId, productName: item.productName, color: item.color, colorName: item.colorName, size: item.size, quantity: 1, unitPrice: item.unitPrice }
        dispatch(updateCartItem(data))
    }
    const handleMinus = () => {
        const data = { productId: item.productId, productName: item.productName, color: item.color, colorName: item.colorName, size: item.size, quantity: -1, unitPrice: -item.unitPrice }
        dispatch(updateCartItem(data))
    }
    const handleDelete = () => {
        const data = { productId: item.productId, productName: item.productName, color: item.color, colorName: item.colorName, size: item.size, quantity: 1, unitPrice: item.unitPrice }
        dispatch(removeCartItem(data))
    }
    return (
        <div className='p-5 shadow-lg border rounded-md'>
            <div className='flex items-center'>
                <div className='w-[5rem] h-[5rem] lg:w-[9rem] lg:h-[9rem]' >
                    <img className='w-full h-full object-cover' alt={item.productName} src={(IMAGES_URL + item.productId + "-" + item?.color + "-00.jpg")} />
                </div>
                <div className='ml-5 space-y-1'>
                    <p className='font-semibold'>{item.productName}</p>
                    <p className='opacity-70 text-xs'>Mã: {item.productId}</p>
                    <p className='opacity-70'>Màu: {item.colorName}</p>
                    <p className='opacity-70'> Kích cỡ: {item.size}</p>
                    <p className='opacity-70 mt-2'>Giá: {VND.format(item.unitPrice * 1000)}</p>
                </div>

            </div>
            <div className='lg:flex items-center lg:space-x-10 pt-4'>
                <div className='flex items-center space-x-2'>
                    <IconButton onClick={handleMinus}>
                        <RemoveCircleOutlineIcon />
                    </IconButton>
                    <span className='py-1 px-7 border rounded-sm'>{item.quantity}</span>
                    <IconButton sx={{ color: "RGB(145 86 254)" }} onClick={handleAdd}>
                        <AddCircleOutlineIcon />
                    </IconButton>


                </div>
                <div>
                    <Button sx={{ color: "RGB(145 86 254)" }} onClick={handleDelete} >Xóa</Button>
                </div>
            </div>

        </div>
    )
}
